import { useQuery } from "@/api/utils/useQuery"
import { QueryResult } from "@/api/utils/types"
import { BackofficeRestQueries } from "@/api/backofficeRest/queries"
import { IContact } from "@/models/contacts/contact.types"
import {
  ContactParser,
  IAccountContactRaw,
} from "@/models/contacts/contact.parser"
import dayjs from "dayjs"

/*
  ark's GET filtered the mirror it served: it dropped cancelled contacts and
  those whose end date had passed. The gateway is a thin Junifer proxy and does
  no filtering, so the FE reproduces the filter to keep the agent's list as it
  is today. A FUTURE toDttm is deliberately KEPT — that contact is still valid
  while the agent is looking at the account.
*/
const isCurrentContact = (contact: IAccountContactRaw): boolean => {
  if (contact.cancelled) return false
  return !contact.toDttm || dayjs(contact.toDttm).isAfter(dayjs())
}

export interface IContactService {
  getForAccount(billingAccountId: number | null): QueryResult<IContact[]>
}

class ContactServiceClass implements IContactService {
  getForAccount(billingAccountId: number | null): QueryResult<IContact[]> {
    return useQuery<IAccountContactRaw[], IContact[]>({
      ...BackofficeRestQueries.account.contacts(billingAccountId ?? -1),
      enabled: !!billingAccountId,
      useRawResponse: true,
      placeholderData: [],
      parserFn: (data) =>
        (data ?? [])
          .filter(isCurrentContact)
          .map((contact) => ContactParser.toDomain(contact)),
      showSnackbarError: true,
      meta: {
        errorMessage: `Failed to fetch contacts for account: ${billingAccountId}`,
      },
    })
  }
}

export const ContactService = new ContactServiceClass()
